import { InfoCircleOutlined } from "@ant-design/icons";
import { Flex, Typography, Button, Popover } from "antd";
import { useSearchParams } from "react-router-dom";
import { DocFolderIcon, DelIcon } from "@shared/assets/svg/icons";
import { DocstoreSections as Sections } from "../../model/constants";
import { getSelectedSectionFromParams } from "../../model/utils";
import "./docstore-sections.scss";

export function DocstoreSections() {
  const [searchParams, setSearchParams] = useSearchParams();
  const selectedSection = getSelectedSectionFromParams(searchParams);

  return (
    <Flex vertical className="sections">
      <Flex justify="space-between" align="start">
        <Typography.Title level={4} className="docstore-sections-title">
          Разделы
        </Typography.Title>
        <Popover
          content="Информация о полномочиях"
          trigger="click"
          arrow={false}
        >
          <Flex gap="small" style={{ cursor: "pointer" }}>
            <InfoCircleOutlined />
            Мои полномочия
          </Flex>
        </Popover>
      </Flex>
      <Flex align="start" gap="small" wrap="wrap">
        {Object.keys(Sections).map((sectionKey) => {
          const section = sectionKey as keyof typeof Sections;
          const sectionValue = Sections[section];
          return (
            <Button
              key={sectionKey}
              icon={section === "TRASH" ? <DelIcon /> : <DocFolderIcon />}
              iconPosition="start"
              variant={
                selectedSection === section
                  ? "outlined"
                  : "filled"
              }
              color={
                selectedSection === section
                  ? "primary"
                  : "default"
              }
              className={
                selectedSection === section
                  ? "section-button"
                  : ""
              }
              style={{
                opacity: section === "TRASH" ? "20%" : "100%",
                backgroundColor: section === "TRASH" ? "#EAEEF8" : "",
                color: section === "TRASH" ? "#333333" : "",
              }}
              disabled={section === "TRASH"}
              onClick={() => setSearchParams({ documentType: section })}
            >
              {sectionValue}
            </Button>
          );
        })}
      </Flex>
    </Flex>
  );
}
